var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: ['gg-group', {
      'gg-group_factoid': _vm.enableFactoid
    }]
  }, [_vm.title ? _c('div', {
    staticClass: "gg-group__title-wrap"
  }, [_c('GGGroupTitle', {
    attrs: {
      "title": _vm.title,
      "timer-date": _vm.titleTimerDate,
      "timer-color": _vm.titleTimerColor,
      "timer-size": _vm.titleTimerSize,
      "icon-left": _vm.titleIconLeft,
      "icon-right": _vm.titleIconRight,
      "img-desktop": _vm.titleImageDesktop,
      "img-mobile": _vm.titleImageMobile,
      "img-link": _vm.titleImageLink,
      "promocode": _vm.titlePromocode,
      "promocode-color": _vm.titlePromocodeColor
    }
  }), _vm._v(" "), _vm.link ? _c('GGLink', {
    staticClass: "gg-group__desktop-link",
    attrs: {
      "to": _vm.link
    }
  }, [_vm._v("\n      " + _vm._s(_vm.linkText ? _vm.linkText : "Перейти") + "\n    ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _vm.enableFactoid ? _c('div', {
    class: ['gg-group__factoid', ("gg-group__factoid_" + (_vm.order))]
  }, [_vm._t("factoid")], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "gg-group__content"
  }, [_vm._t("content")], 2), _vm._v(" "), _vm.link ? _c('GGLink', {
    staticClass: "gg-group__mobile-link",
    attrs: {
      "to": _vm.link
    }
  }, [_vm._v("\n    " + _vm._s(_vm.linkText ? _vm.linkText : "Смотреть все товары") + "\n  ")]) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }